import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si nunca aposté en serio o soy principiante absoluto?',
    a: 'El Masterpack está diseñado específicamente para empezar desde cero. El Tomo 1 explica desde qué es una cuota y cómo funciona el margen del bookmaker, sin asumir ningún conocimiento previo. Muchos de nuestros compradores son fanáticos del fútbol argentino que depositaron en apps de apuestas sin entender realmente cómo funcionaba el mercado. El sistema los llevó del "apuesto por intuición" al "apuesto con criterio" paso a paso.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de tu pago, recibís un correo electrónico con el enlace de descarga de todos los PDFs. El acceso es de por vida — no vence ni caduca. Podés descargarlo en tu teléfono, tablet o computadora. Está optimizado para leer en pantalla y también para imprimir las secciones que más uses.'
  }, {
    q: '¿Con qué plataformas de apuestas funciona?',
    a: 'Con todas las disponibles en Argentina. Bet365, Betway, Codere, Betsson, 1xBet y cualquier plataforma que opere con Mercado Pago o transferencia bancaria local. El Tomo 2 incluye una tabla comparativa específica con las plataformas más usadas en el mercado argentino, sus métodos de cobro y sus velocidades de retiro reales.'
  }, {
    q: '¿Garantiza que voy a ganar dinero apostando?',
    a: 'No. Ningún sistema educativo honesto puede garantizar resultados financieros en las apuestas deportivas. Lo que garantiza el Masterpack es que vas a entender el mercado de apuestas desde adentro, vas a analizar partidos con criterio estructurado, vas a gestionar tu capital con matemáticas reales y vas a tomar decisiones informadas en lugar de impulsivas. El resultado financiero depende de la aplicación consistente del sistema en el largo plazo.'
  }, {
    q: '¿El Elite System es necesario o con el Masterpack base alcanza?',
    a: 'El Masterpack base es un sistema completo que cubre absolutamente todo lo que necesitás para apostar con criterio en el Mundial. El Elite System está diseñado para apostadores que ya aplicaron el sistema base y quieren profundizar en análisis estadístico avanzado, psicología de rendimiento y herramientas de tracking automatizadas. Si es tu primera vez apostando con sistema, empezá por el Masterpack. Si ya tenés experiencia y buscás el siguiente nivel, el Elite System es el paso natural.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si lo abrís, lo usás y no es lo que esperabas, te devolvemos el 100% del dinero sin preguntas, sin formularios y sin drama. Escribís a masterpackmundial@gmail.com y procesamos el reembolso en 48 horas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-black" data-id="element-76">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-77">
        <h2 className="text-3xl font-extrabold text-center text-white mb-12" data-id="element-78">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-79">
          {faqs.map((faq, i) => <div key={i} className="border border-amber-900/40 rounded-2xl overflow-hidden bg-zinc-900/60" data-id="element-80">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 hover:bg-zinc-900/40 transition-colors" aria-expanded={openIndex === i} data-id="element-81">
                <span className="font-bold text-white pr-4" data-id="element-82">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-amber-300 transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-83" />
              </button>

              <AnimatePresence data-id="element-84">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-85">
                    <div className="px-6 pb-5 text-zinc-200 leading-relaxed border-t border-amber-900/30 pt-3" data-id="element-86">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}